<dx-file-manager id="fileManager" [fileSystemProvider]="sandboxFiles" currentPath="Widescreen">
    <dxo-permissions [create]="true" [copy]="true" [move]="true" [delete]="true" [rename]="true" [upload]="true"
        [download]="true">
    </dxo-permissions>
    <dxo-toolbar>
        <dxi-item name="download" icon="assets/icons/download.svg"></dxi-item>
        <dxi-item name="move"></dxi-item>
        <dxi-item name="copy"></dxi-item>
        <dxi-item name="rename"></dxi-item>
        <dxi-item name="delete"></dxi-item>
        <dxi-item name="refresh"></dxi-item>
        <dxi-item name="switchView"></dxi-item>
    </dxo-toolbar>
</dx-file-manager>